const CUSTOM_REGEX = /[a-zA-Z0-9\s-]/;
const CUSTOM_REGEX_WITH_UNDERSCORE = /[a-zA-Z0-9\s._-]/;
export const SPECIAL_CHARACTERS_MASK = [
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
    CUSTOM_REGEX,
];
export const SPECIAL_CHARACTERS_MASK_WITH_UNDERSCORE = [
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
    CUSTOM_REGEX_WITH_UNDERSCORE,
];

export const THREE_NUMBERS_MASK = '999';
export const FIVE_NUMBERS_MASK = '99999';
export const NINE_NUMBERS_MASK = '999999999';
